import { useContext } from 'react';
import { MainContext } from '@/context/MainContext';
import Link from '@/components/Link';
import NewLabel from '@/components/NewLabel';

import styles from './custom-submenus.module.css';

const CasesSubmenu = ({ onClickItem }) => {
  const { main } = useContext(MainContext);

  return (
    <div className={styles.root}>
      <div className={styles.solutions}>
        {main?.solutions.map(({ name, href, isNew }) => (
          <Link className={styles.solution} href={href} onClick={onClickItem} key={name}>
            {name} {isNew && <NewLabel />}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CasesSubmenu;
